import React, { useCallback } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { NavigationParams } from 'types/params';
import {
    getTabUrlQueryParamState,
    combineQueryStrings,
    getPartOfCurrentQueryString,
} from 'helpers';
import { TabNames } from 'types/enums';
import getDetailsViewTabs from './helpers/getDetailsViewTabs';

const useDetailsView = ({
    children,
    search,
    pathname,
    activeTabTotal,
    navigate,
}: {
    search: string;
    pathname: string;
    navigate: NavigateFunction;
    activeTabTotal?: number;
    children: React.ReactNode;
}) => {
    const handleSelectTab = useCallback(
        (nextTab: TabNames) => {
            const clearedQueryString = getPartOfCurrentQueryString({
                routerQueryString: search,
                queriesToExclude: [NavigationParams.tab, NavigationParams.page],
            });

            const queryString = combineQueryStrings(
                clearedQueryString,
                `${NavigationParams.tab}=${nextTab}`,
            );

            navigate({
                pathname: pathname,
                search: `?${queryString}`,
            });
        },
        [navigate, pathname, search],
    );

    const childrenArray = React.Children.toArray(children);

    const { firstTab, secondTab } = getDetailsViewTabs({
        childrenArray,
    });

    const defaultTabs = firstTab.name;
    const activeTab = getTabUrlQueryParamState(search, defaultTabs);

    const showTabs = !!secondTab?.position;

    return {
        activeTab,
        handleSelectTab,
        firstTab,
        secondTab,
        showTabs,
    };
};

export default useDetailsView;
